import type { TOC } from '@ember/component/template-only'
import type { ThemeKeys } from 'teacher-ui-client/utils/themes'
import { eq } from 'ember-truth-helpers'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import t from 'ember-intl/helpers/t'

interface Signature {
  Element: HTMLTableElement
  Args: {
    themeKey?: ThemeKeys
    rows: {
      index: string
      message: string
    }[]
  }
}

export const ErrorsTable: TOC<Signature> = <template>
  <table ...attributes>
    <thead>
      <tr
        class="{{if (eq @themeKey 'blue') 'bg-oceany-blue-100'}}
          {{if (eq @themeKey 'green') 'bg-ms-green-100'}}
          {{if (eq @themeKey 'dark-blue') 'bg-wl-blue-100'}}"
      >
        <th class="w-0 px-4 py-2"></th>
        <th class="px-4 py-2">{{t "manage.bulkActions.csv.lineNo"}}</th>
        <th class="px-4 py-2">{{t "manage.bulkActions.csv.rowErrorHeading"}}</th>
      </tr>
    </thead>
    <tbody>
      {{#each @rows as |row index|}}
        <tr data-test-row={{index}} class="'text-watermelony-red-350 even:bg-dusty-black-50 hover:bg-dusty-black-100">
          <td class="px-4 py-2">
            <PhosphorIcon @icon="phosphor-warning-circle-fill" />
          </td>
          <td class="px-4 py-2">{{row.index}}</td>
          <td class="px-4 py-2">{{row.message}}</td>
        </tr>
      {{/each}}
    </tbody>
  </table>
</template>
